const EventSeatIcon = (
  <svg
    className="fill-none"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12V7C7 5.9 7.9 5 9 5H15C16.1 5 17 5.9 17 7V12M5 12H19V16H17V19H15V16H9V19H7V16H5V12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EventSeatIcon;